(ns hai.home.desktop.mini-apps.tips-and-tricks
  "Tips and tricks mini-app card. For now it shows the steps for getting
   Humble onto every surface, each stamped done in its own box. Sits under the
   clock on Home and wears the shared mini-app frame, its header in system
   gray. The checklist and ⋮ actions are shared with the mobile card, in
   [[hai.home.tips-and-tricks]]; whether the card is collapsed is its web-app
   placement, in [[hai.mini-apps.data]]."
  (:require
   [hai.entity.kebab :as kebab]
   [hai.home.desktop.onboarding :as desktop-onboarding]
   [hai.home.tips-and-tricks :as tips-and-tricks]
   [hai.mini-apps.data :as mini-apps-data]
   [hai.mini-apps.frame :as mini-apps]
   [hai.onboarding :as onboarding]
   [hai.ui.icons :as icons]
   [hai.ui.rf-sugar :refer [<s >e]]
   [hai.ui.tokens :as t]
   [lambdaisland.ornament :as o]))

(def ^:private lightbulb-icon (icons/mui-icon :outlined :lightbulb))

;; The tour step's label opens the tour.
(def ^:private steps
  (mapv (fn [{:keys [key] :as step}]
          (cond-> step
            (= key :onboarding.step/desktop-tour)
            (assoc :on-click #(>e [::desktop-onboarding/open]))))
        onboarding/desktop-steps))

;; ---------------------------------------------------------------------------
;; Card frame
;; ---------------------------------------------------------------------------

(o/defstyled card mini-apps/card
  {:min-width "380px" :margin-top "16px"}
  ;; Duck tape on the right, so it doesn't line up with the clock's above.
  [:&::before {:left "auto" :right "40px"}]

  ;; Header: system gray rather than a content hue — this is Humble's own card,
  ;; not one of the user's apps.
  [:.app-header {:background t/--system}]
  ;; :lightbulb is a Material fill icon, unlike the stroke icons the shared card
  ;; frame assumes, so restore fill and match the other header icons' size.
  [:.app-icon [:svg {:fill "currentColor" :width "20px" :height "20px"}]]
  ;; Body padding lives here since the shared card frame leaves the body to each
  ;; mini-app (the header band supplies its own padding).
  [:.setup-body {:padding "16px 18px 18px"}])

;; ---------------------------------------------------------------------------
;; Pieces
;; ---------------------------------------------------------------------------

(defn- card-header
  [title collapsed?]
  [:div.app-header
   [:span.app-icon [lightbulb-icon]]
   [:h2.app-title title]
   [:div.app-actions
    [mini-apps/collapse-toggle
     {:collapsed? collapsed?
      :label      "tips and tricks"
      :class      "app-action-btn"
      :on-toggle  #(>e [::mini-apps-data/toggle-collapsed :tips-and-tricks])}]
    [kebab/menu
     {:actions    (tips-and-tricks/menu-actions steps)
      :aria-label "Tips and tricks actions"}]]])

;; ---------------------------------------------------------------------------
;; Panel
;; ---------------------------------------------------------------------------

(defn panel [{title :mini-app/title}]
  (let [collapsed? @(<s [::mini-apps-data/collapsed? :tips-and-tricks])]
    [card {:class (when collapsed? "collapsed")}
     [card-header title collapsed?]
     (when-not collapsed?
       [:div.setup-body
        [tips-and-tricks/setup-checklist steps]])]))
